var _rect, _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F5F5F5"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H24V1.84615H0V0ZM0 3.69231H24V5.53846H0V3.69231ZM24 7.38462H0V9.23077H24V7.38462ZM0 11.0769H24V12.9231H0V11.0769ZM24 14.7692H0V16.6154H24V14.7692ZM0 18.4615H24V20.3077H0V18.4615ZM24 22.1538H0V24H24V22.1538Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12.9231,
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4 2.76923L2.82 3.23077L3.36 2.86154L3.18 3.46154L3.72 3.69231L3.12 3.69231L3 4.30769L2.76 3.76923L2.16 3.92308L2.64 3.46154L2.4 2.76923ZM5.04 2.76923L5.46 3.23077L6 2.86154L5.82 3.46154L6.36 3.69231L5.76 3.69231L5.64 4.30769L5.4 3.76923L4.8 3.92308L5.28 3.46154L5.04 2.76923ZM8.1 3.23077L7.68 2.76923L7.92 3.46154L7.44 3.92308L8.04 3.76923L8.28 4.30769L8.4 3.69231L9 3.69231L8.46 3.46154L8.64 2.86154L8.1 3.23077ZM10.32 2.76923L10.74 3.23077L11.28 2.86154L11.1 3.46154L11.64 3.69231L11.04 3.69231L10.92 4.30769L10.68 3.76923L10.08 3.92308L10.56 3.46154L10.32 2.76923ZM2.82 6L2.4 5.53846L2.64 6.23077L2.16 6.69231L2.76 6.53846L3 7.07692L3.12 6.46154L3.72 6.46154L3.18 6.23077L3.36 5.63077L2.82 6ZM5.46 6L5.04 5.53846L5.28 6.23077L4.8 6.69231L5.4 6.53846L5.64 7.07692L5.76 6.46154L6.36 6.46154L5.82 6.23077L6 5.63077L5.46 6ZM7.68 5.53846L7.92 6.23077L7.44 6.69231L8.04 6.53846L8.28 7.07692L8.4 6.46154L9 6.46154L8.46 6.23077L8.64 5.63077L8.1 6L7.68 5.53846ZM10.74 6L10.32 5.53846L10.56 6.23077L10.08 6.69231L10.68 6.53846L10.92 7.07692L11.04 6.46154L11.64 6.46154L11.1 6.23077L11.28 5.63077L10.74 6ZM2.4 8.30769L2.82 8.76923L3.36 8.4L3.18 9L3.72 9.23077L3.12 9.23077L3 9.84615L2.76 9.30769L2.16 9.46154L2.64 9L2.4 8.30769ZM5.04 8.30769L5.46 8.76923L6 8.4L5.82 9L6.36 9.23077L5.76 9.23077L5.64 9.84615L5.4 9.30769L4.8 9.46154L5.28 9L5.04 8.30769ZM8.1 8.76923L7.68 8.30769L7.92 9L7.44 9.46154L8.04 9.30769L8.28 9.84615L8.4 9.23077L9 9.23077L8.46 9L8.64 8.4L8.1 8.76923ZM10.32 8.30769L10.74 8.76923L11.28 8.4L11.1 9L11.64 9.23077L11.04 9.23077L10.92 9.84615L10.68 9.30769L10.08 9.46154L10.56 9L10.32 8.30769ZM2.82 11.5385L2.4 11.0769L2.64 11.7692L2.16 12.2308L2.76 12.0769L3 12.6154L3.12 12L3.72 12L3.18 11.7692L3.36 11.1692L2.82 11.5385Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 2.16,
    y: 2.76923,
    width: 9.48,
    height: 9.84615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.ff5d8575ce3f31c79d8b7f1e4e7f1edb.svg";
export { ForwardRef as ReactComponent };